var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniLearningPromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 7.99967C8.62609 7.99967 7.94781 8.28063 7.44772 8.78072C6.94762 9.28082 6.66667 9.9591 6.66667 10.6663V24.7807L9.72386 21.7235C9.97391 21.4735 10.313 21.333 10.6667 21.333H22.6667C23.3739 21.333 24.0522 21.0521 24.5523 20.552C25.0524 20.0519 25.3333 19.3736 25.3333 18.6663V16.7106C25.3333 15.9743 25.9303 15.3773 26.6667 15.3773C27.403 15.3773 28 15.9743 28 16.7106V18.6663C28 20.0808 27.4381 21.4374 26.4379 22.4376C25.4377 23.4378 24.0812 23.9997 22.6667 23.9997H11.219L6.27614 28.9425C5.89481 29.3238 5.32132 29.4379 4.82309 29.2315C4.32486 29.0251 4 28.539 4 27.9997V10.6663C4 9.25185 4.5619 7.8953 5.5621 6.8951C6.56229 5.89491 7.91885 5.33301 9.33333 5.33301H16.178C16.9143 5.33301 17.5113 5.92996 17.5113 6.66634C17.5113 7.40272 16.9143 7.99967 16.178 7.99967H9.33333Z",
    fill: "#7048E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLearningPromptIcon);
export default __webpack_public_path__ + "static/media/MiniLearningPromptIcon.55a67c46d296624228ef3a04a37e68bb.svg";
export { ForwardRef as ReactComponent };